const defaultCompanySettings = {
    applicationName: 'Porsche Trade In',
    companyName: 'Porsche Singapore',
    contactEmail: 'jeremy.lau@porsche.sg',
    currency: '$',
    currencyCode: 'SGD',
    timezone: 'Asia/Singapore',
    countryCode: '65',
    logo: null,
    favicon: null,
    formats: {
        longDateFormat: 'D MMM YYYY',
        shortDateFormat: 'DD/MM/YY',
        datePickerFormat: 'DD/MM/YY',
        timePickerFormat: 'hh:mm A',
        dateTimePickerFormat: 'DD/MM/YY hh:mm A',
        longDateTimeFormat: 'DD/MM/YY, hh:mm A',
        dateFormatForTemplate: 'DD MMM YYYY',
    },
    passwordPolicy: {
        minPasswordLength: 12,
    },
    fileSettings: {
        maxUploadFileSize: 5, // in MB
        allowedImageFileExtensions: ['jpg', 'jpeg', 'png'],
        allowedDocFileExtensions: ['pdf'],
    },
};

export default defaultCompanySettings;
